import { Alert, Box } from "@mui/material";
import { SEARCH_RESULTS_LOADING_MESSAGES } from "./constants";
import SearchResultsHeader from "./search-results-header";
import RuleBreaks from "./rule-breaks/rule-breaks";
import StyledDataGrid from "./styled-grid-data";
import LoadingScreen from "../progress/loading-screen";
import { columns } from "./grid-data";
import { useSearch } from "../search/search-context";
import getOptionalSearchValues from "./helpers";
import useSearchResultsData from "./use-search-results-data";

const SearchResults = () => {
  const form = useSearch();
  const { data, error, isLoading } = useSearchResultsData();

  if (isLoading) {
    return (
      <LoadingScreen
        dataTestId="search-results-loading"
        loadingMessages={SEARCH_RESULTS_LOADING_MESSAGES}
      />
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ marginTop: 2 }}>
        {error}
      </Alert>
    );
  }

  return data ? (
    <Box id="search-results" sx={{ minHeight: "200px" }}>
      <RuleBreaks ruleBreaks={data?.ruleBreaks} />
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          borderRadius: "8px",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          marginTop: 2,
        }}
      >
        <SearchResultsHeader
          result={data?.result}
          claimReference={form.claimReference}
          searchOptionals={getOptionalSearchValues(form)}
        />

        {data?.incidents?.length > 0 && (
          <Box sx={{ padding: (theme) => theme.spacing(3) }}>
            <StyledDataGrid
              rows={data.incidents}
              columns={columns}
              loading={isLoading}
              getRowClassName={() => `super-app-theme`}
              getCellClassName={() => "super-app-theme--cell"}
              sx={{
                height: 700,
                border: "none",
                padding: 0,
                borderColor: "primary.light",
                "& .MuiDataGrid-cell:hover": {
                  color: "primary.main",
                },
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  ) : null;
};

export default SearchResults;
